import AppModal from '@/components/AppModal';
import { SuccessResponseModal } from '@/components/AppModal/modals';
import useFormSubmit from '@/hooks/useFormSubmit';
import usePaginatedQuery from '@/hooks/usePaginatedQuery';
import { getConfig } from '@/services/config.service';
import { postCreateSendSms } from '@/services/send_sms.service';
import { useMutation } from '@tanstack/react-query';
import { Button, Form, Input, Select, Tag } from 'antd';
import { isArray } from 'lodash';
import React, { useEffect, useState } from 'react';

function CreateSendSMSModal({ openModal, setOpenModal, refetchOverviewData }) {
  const [form] = Form.useForm();
  const [isdnTags, setIsdnTags] = useState([]);
  const [typeOption, setTypeOption] = useState([]);
  const [typeValue, setTypeValue] = useState(null);
  const { data, isLoading } = usePaginatedQuery(
    () =>
      getConfig({
        message_take_prize: true,
      }),
    ['config']
  );

  useEffect(() => {
    if (data && isArray(data) && !isLoading) {
      setTypeOption([
        ...data?.map((item) => ({
          label: item.config_key
            .split('_')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' '),
          value: item.config_value_my,
        })),
        {
          label: 'Other',
          value: 0,
        },
      ]);
    }
  }, [data, isLoading]);

  // console.log('typeValue', typeValue);

  useEffect(() => {
    if (typeValue && typeValue !== 0) {
      form.setFieldValue('content', typeValue);
    } else {
      form.setFieldValue('content', '');
    }
  }, [typeValue]);

  const createSmsMutation = useMutation({
    mutationFn: postCreateSendSms,
  });

  const handleIsdnChange = (e) => {
    const value = e.target.value;
    const tags = value
      .split(',')
      .map((v) => v.trim())
      .filter((v) => v !== '');
    setIsdnTags(tags);
    form.setFieldValue('isdn_list', value);
  };

  // const removeTag = (removedTag) => {
  //   const newTags = isdnTags.filter((tag) => tag !== removedTag);
  //   setIsdnTags(newTags);
  //   form.setFieldValue('isdn_list', newTags.join(','));
  // };

  const handleSubmit = useFormSubmit(
    createSmsMutation,
    (values) => {
      let payload = {};
      const { type, ...restValues } = values;
      console.log('values', values);

      if (typeValue === 0) {
        payload = {
          ...restValues,
          type: type,
          content: values.content,
        };
      } else {
        payload = {
          ...restValues,
          content: typeValue,
        };
      }

      return payload;
    },
    {
      onSuccess: () => {
        SuccessResponseModal({
          onOk: async () => {
            await refetchOverviewData();
            handleClose();
          },
        });
      },
    }
  );

  const handleClose = () => {
    setOpenModal(false);
    form.resetFields();
  };

  return (
    <AppModal
      title="Create SMS"
      open={openModal}
      okText="Send SMS"
      onOk={() => form.submit()}
      onCancel={handleClose}
      closable
      closeIcon={null}
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={handleSubmit}
        disabled={createSmsMutation.isPending}
      >
        <Form.Item
          label="Title"
          name="title"
          required
          rules={[{ required: true, message: 'Please enter title' }]}
        >
          <Input placeholder="Please enter title" />
        </Form.Item>

        <Form.Item
          label="Type"
          name="type"
          required
          rules={[{ required: true, message: 'Please select type' }]}
        >
          <Select
            options={[...typeOption]}
            onChange={(value) => setTypeValue(value)}
            placeholder="Please select type"
          />
        </Form.Item>

        <Form.Item
          label="Content"
          name="content"
          required
          rules={[{ required: true, message: 'Please enter content' }]}
        >
          <Input.TextArea placeholder="Please enter content" autoSize readOnly={typeValue !== 0} />
        </Form.Item>

        {typeValue !== 0 && (
          <Form.Item label="Prize Name" name="prize_name">
            <Input placeholder="Please enter prize name" />
          </Form.Item>
        )}

        <Form.Item
          label="ISDN List"
          name="isdn_list"
          required
          rules={[{ required: true, message: 'Please enter ISDN list' }]}
          extra="Separate by comma, no space"
        >
          <>
            <Input placeholder="Enter ISDNs separated by comma" onChange={handleIsdnChange} />
            <div style={{ marginTop: 8, display: 'flex', flexWrap: 'wrap', gap: 4 }}>
              {isdnTags.map((tag) => (
                <Tag key={tag} closable={false}>
                  {tag}
                </Tag>
              ))}
            </div>
          </>
        </Form.Item>
      </Form>
    </AppModal>
  );
}

export default CreateSendSMSModal;
